var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 171,
    viewBox: "0 0 390 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.294 0.0263672H27.4228C21.0323 0.0263672 4.17949 4.46152 0 31.2606H389.717C385.564 4.46152 368.685 0.0263672 362.294 0.0263672Z",
    fill: "url(#paint0_linear_2221_26928)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.952 149.344L202.476 169.638C197.46 170.686 192.283 170.686 187.295 169.638L89.8183 149.344C72.615 145.769 60.2653 130.635 60.2653 113.083V54.7002C60.2653 -3.8147e-06 27.4766 0 27.4766 0H362.348C362.348 0 329.559 -3.8147e-06 329.559 54.7002V113.083C329.559 130.609 317.236 145.742 300.006 149.344H299.952Z",
    fill: "url(#paint1_linear_2221_26928)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2221_26928",
    x1: 194.845,
    y1: 1.58539,
    x2: 194.845,
    y2: 29.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#291A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#341D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#41207E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#4A238F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#502498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#52259C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#49218C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2E185F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24154E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2221_26928",
    x1: 194.845,
    y1: -2.68797,
    x2: 194.845,
    y2: 165.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#523589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#663CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7441B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7D44BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8045BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7D43BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#53318D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442A7C"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBack);
export default __webpack_public_path__ + "static/media/textBack.70a3e1f63e340cc03bd648336f8c82e1.svg";
export { ForwardRef as ReactComponent };